import { render, staticRenderFns } from "./space.vue?vue&type=template&id=ec0ab830&scoped=true"
import script from "./space.vue?vue&type=script&lang=js"
export * from "./space.vue?vue&type=script&lang=js"
import style0 from "./space.vue?vue&type=style&index=0&id=ec0ab830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0ab830",
  null
  
)

export default component.exports